import { IntroductionScreen } from "../../screens/introduction"
import { PlayScreen } from "../../screens/play"
import { SetupScreen } from "../../screens/setup"

export const navigationScreens = {
  introduction: IntroductionScreen,
  play: PlayScreen,
  setup: SetupScreen,
}
